
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 3104","fill":"currentColor"}},[_c('path',{attrs:{"data-name":"Rectangle 1640","d":"M10.655 6.285h7.599v1.448h-7.599z"}}),_c('path',{attrs:{"data-name":"Rectangle 1641","d":"M10.655 9.614h7.599v1.448h-7.599z"}}),_c('path',{attrs:{"data-name":"Rectangle 1642","d":"M10.655 12.941h7.599v1.448h-7.599z"}}),_c('path',{attrs:{"data-name":"Rectangle 1643","d":"M10.655 16.27h7.599v1.448h-7.599z"}}),_c('path',{attrs:{"data-name":"Rectangle 1644","d":"M6.966 6.283h.959v4.827h-.959z"}}),_c('path',{attrs:{"data-name":"Path 2216","d":"M7.682 16.743l.878-1.556a1.7 1.7 0 00.232-.887 1.669 1.669 0 00-2.86-1.128l-.187.2.7.7.2-.218a.645.645 0 01.475-.212.672.672 0 01.7.667.73.73 0 01-.11.39L6.018 17.71h3.3v-.971z"}})])])
          )
        }
      }
    